import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './VerifyPage.css';

const VerifyPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyUserEmail = async () => {
      const token = searchParams.get('token');
      const email = searchParams.get('email');

      if (!token || !email) {
        setStatus('error');
        setError('Invalid verification link. Missing token or email.');
        return;
      }

      try {
        console.log('Verifying email with token:', token, 'and email:', email);
        
        // Use our Netlify function to verify the email
        const response = await fetch('/.netlify/functions/verify-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token,
            email,
          }),
        });
        
        const result = await response.json();
        
        if (!response.ok || !result.success) {
          throw new Error(result.error || 'Verification failed');
        }
        
        setStatus('success');
        
        // Automatically redirect to dashboard after a short delay
        // The magic link generated in the verify-email.js function will handle the authentication
        setTimeout(() => {
          navigate('/dashboard');
        }, 3000);
      } catch (err) {
        console.error('Verification error:', err);
        setStatus('error');
        setError(err.message || 'Failed to verify email. Please try again or contact support.');
      }
    };

    verifyUserEmail();
  }, [searchParams, navigate]);

  const handleGoToLogin = () => {
    navigate('/login');
  };

  const handleGoToSignup = () => {
    navigate('/signup');
  };

  return (
    <div className="verify-page">
      <div className="verify-card">
        <h1 className="verify-title">Email Verification</h1>
        
        {status === 'verifying' && (
          <div className="verify-loading">
            <div className="spinner"></div>
            <p>Verifying your email address...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="verify-success">
            <div className="alert alert-success">
              <h4>Success</h4>
              <p>Your email has been successfully verified!</p>
            </div>
            <p>You can now log in to your account.</p>
            <div className="verify-buttons">
              <button 
                className="button button-primary"
                onClick={handleGoToLogin}
              >
                Go to Login
              </button>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="verify-error">
            <div className="alert alert-error">
              <h4>Error</h4>
              <p>{error}</p>
            </div>
            <p>Please try again or sign up with a different email address.</p>
            <div className="verify-buttons">
              <button 
                className="button button-primary"
                onClick={handleGoToSignup}
              >
                Sign Up
              </button>
              <button 
                className="button button-secondary"
                onClick={handleGoToLogin}
              >
                Go to Login
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyPage;
